import styled from '@emotion/styled';

const InvalidMessage = styled('div')`
    color: var(--brandDanger);
    font-weight: bold;
`;

export default InvalidMessage;
